/**
 * @(#)2019/7/15.
 * YxCheckbox，可以进行多选
 * @author 飞光
 * Copyright (c) 2019, YUNXI. All rights reserved.
 * YUNXI PROPRIETARY/CONFIDENTIAL. Use is subject to license terms.
 */

import React, { Component } from "react";
import ReactDOM from "react-dom";
import Utils from "../../utils";
import Basics from "./Basics";
import { Checkbox } from "antd";
import { YxComponent, Connection } from "../YxComponent";
import { IcheckboxPropTypes } from "./IpropType/checkboxPropType";

/*
 * @param type {enum} 控件类型 group/""  分组/单个
 * @param data {array} 分组的数据，等于  原antd options
 *
 * @param children {ReactNode} react节点
 *
 * @param styleParam {object} 样式参数
 * @param styleParam.size {string} 大小，暂时只支持default
 * @param styleParam.type {string} 类型，暂时只支持default
 * */
//默认props
let defaul = () => {
  return {
    inputParam: {},
    children: "", //子节点,子节点暂时只支持antd的Checkbox
    type: "group", //类型，分组模式
    data: [], //分组的数据
    rules: {},
    styleParam: {
      size: "default", //大小
      type: "default", //类型
    },
  };
};
@Connection(defaul)
class YxCheckbox extends YxComponent {
  productionHtml() {
    let tmpProps = { ...this.props };
    if (this.props.isControlled === true) {
      const change = tmpProps.change;
      tmpProps.change = (e) => {
        // change(e.target.checked)

        change(tmpProps.type === "group" ? e : e.target.checked, tmpProps.id);
      };
    }
    tmpProps.rules.max = "";
    if (tmpProps.type == "group") {
      tmpProps.children = (
        <Checkbox.Group options={tmpProps.data}>
          {tmpProps.children}
        </Checkbox.Group>
      );
    } else {
      const children = tmpProps.children;
      tmpProps.children = <Checkbox>{children}</Checkbox>;
    }

    let classParam = {
      yx_yxCheckbox_: "styleParam.type",
      yx_yxCheckbox_size_: "styleParam.size",
    };
    tmpProps.inputParam.className = this.styleParamClassName(
      tmpProps,
      classParam
    );

    let html = Basics.html(tmpProps);
    return html;
  }
  render() {
    return this.productionHtml();
  }
}

YxCheckbox.propTypes = IcheckboxPropTypes;
YxCheckbox.defaultProps = defaul();
export default YxCheckbox;



// WEBPACK FOOTER //
// ./src/yx-widget/component/YxInput/YxCheckbox.js